import { makeActions } from '@redux/crudCreator/actions';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  cancelTransferOrdersApi,
  confirmPickApi,
  receivedTransferOrdersApi,
  rejectTransferOrdersApi,
} from 'api/transfer';

export const MODEL_NAME = 'transferOrders';
export const transferOrdersActions = makeActions(
  MODEL_NAME,
  'id',
  'transfer-orders',
);

export const getAllTransferOrders = transferOrdersActions.getAll;
export const editTransferOrders = transferOrdersActions.edit;
export const createTransferOrders = transferOrdersActions.create;
export const getByIdTransferOrders = transferOrdersActions.getDataById;

export const confirmPick = createAsyncThunk(
  'transferOrders/confirmPick',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: options?.isShowSuccessNoti },
        confirmPickApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const rejectTransferOrders = createAsyncThunk(
  'transferOrders/rejectTransferOrders',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(options, rejectTransferOrdersApi, data);
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const cancelTransferOrders = createAsyncThunk(
  'transferOrders/cancelTransferOrders',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(options, cancelTransferOrdersApi, data);
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const receivedTransferOrders = createAsyncThunk(
  'transferOrders/cancelTransferOrders',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        options,
        receivedTransferOrdersApi,
        data,
      );
      if (response) {
        return { success: true, response };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
